import React from "react";
import "./ResearcherSignUpPage.css";
import ResSignUpCardWrapper from "../SignUpPage/SubComponent/ResSignUpCardWrapper";

export default function ResercherSignUpPage() {
  return (
    <div className="ResearcherSignUpWrapper">
      <div className="SignUpImageWrapper"></div>
      <ResSignUpCardWrapper></ResSignUpCardWrapper>
    </div>
  );
}
